<template>
    <div class="toggle-btn" @click="$emit('click')">
        <IconArrow />
    </div>
</template>

<script>
import IconArrow from '@/views/track/icons/IconArrow.vue';

export default {
    components: {
        IconArrow,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.toggle-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: urem(4);
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(70, 99, 171, 1);
    z-index: 3;
    width: 100%;

    position: absolute;
    bottom: urem(10);
    left: 0;

    svg {
        width: urem(16);
        height: urem(16);
    }
}
</style>
